/**
 * key [String] only used to identify customized layout
 * name [String] display name in i18n key string
 * list [Array] menu items
 * link [String] hyperlink value
 * disable [Boolean] is item disabled clicking
 */
export const navItems = [
  {
    key: 'solutions',
    name: 'navigation.category1.name',
    list: [
      {
        name: 'navigation.category1.list1.name',
        list: [
          {
            name: 'navigation.category1.list1.list1.name1',
            link: '/solutions/video-stream-china/'
          },
          {
            name: 'navigation.category1.list1.list1.name2',
            link: '/solutions/ott-streaming/'
          }
        ]
      },
      {
        name: 'navigation.category1.list2.name',
        list: [
          {
            name: 'navigation.category1.list2.list1.name1',
            link: '/features/china-access/'
          }
        ]
      },
      {
        name: 'navigation.category1.list3.name',
        link: '/features/power-ups/'
      },
      {
        name: 'navigation.category1.list4.name',
        link: '/features/enterprise-support/'
      }
    ]
  },
  {
    key: 'products',
    name: 'navigation.category2.name',
    list: [
      {
        name: 'navigation.category2.list1.name',
        list: [
          {
            key: 'observability',
            name: 'navigation.category2.header.column1',
            list: [
              {
                name: 'navigation.category2.list1.list1.name4',
                link: '/video-stream/video-streaming-analytics-solution'
              }
            ]
          },
          {
            key: 'optimization',
            name: 'navigation.category2.header.column2',
            list: [
              {
                name: 'navigation.category2.list1.list1.name2',
                link: '/video-stream/instream-switching/'
              }
            ]
          },
          {
            key: 'delivery',
            name: 'navigation.category2.header.column3',
            list: [
              {
                name: 'navigation.category2.list1.list1.name1',
                link: '/video-stream/multi-cdn-management/'
              },
              {
                name: 'navigation.category2.list1.list1.name3',
                link: '/video-stream/hybrid-cdn-p2p/'
              },
              {
                name: 'navigation.category2.list1.list1.name5',
                link: '/video-stream/low-latency-live-streaming/'
              }
              // {
              //   name: 'navigation.category1.list1.list1.name1',
              //   link: '/solutions/video-stream-china/'
              // }
            ]
          },
          {
            key: 'monetization',
            name: 'navigation.category2.header.column5',
            list: [
              {
                name: 'navigation.category2.list1.list1.name6',
                disable: true
              }
            ]
          }
        ]
      },
      {
        name: 'navigation.category2.list2.name',
        list: [
          {
            key: 'observability',
            name: 'navigation.category2.header.column1',
            list: [
              {
                name: 'navigation.category2.list2.list1.list1.name2',
                link: '/features/real-user-monitoring/'
              },
              {
                name: 'navigation.category2.list2.list1.list1.name3',
                link: '/features/synthetic-monitoring/'
              },
              {
                name: 'navigation.category2.list2.list1.list1.name1',
                link: '/features/pulse/'
              }
            ]
          },
          {
            key: 'optimization',
            name: 'navigation.category2.header.column2',
            list: [
              {
                name: 'navigation.category2.list2.list2.list1.name2',
                link: '/features/smart-load-balancing/'
              },
              {
                name: 'navigation.category2.list2.list2.list1.name1',
                link: '/features/dns/'
              },
              {
                name: 'navigation.category2.list2.list2.list1.name3',
                link: '/features/routing-policy/'
              }
            ]
          },
          {
            key: 'delivery',
            name: 'navigation.category2.header.column3',
            list: [
              {
                name: 'navigation.category2.list2.list3.list1.name1',
                link: '/features/multi-cdn/'
              },
              {
                name: 'navigation.category2.list2.list3.list1.name2',
                link: 'https://www.mlytics.com/features/power-ups/'
              },
              {
                name: 'navigation.category2.list2.list3.list1.name3',
                link: 'https://www.mlytics.com/features/china-access/'
              }
            ]
          },
          {
            key: 'protection',
            name: 'navigation.category2.header.column4',
            list: [
              {
                name: 'navigation.category2.list2.list4.list1.name2',
                link: '/features/origin-shield/'
              },
              {
                name: 'navigation.category2.list2.list4.list1.name1',
                link: '/features/web-application-firewall/'
              },
              {
                name: 'navigation.category2.list2.list4.list1.name3',
                link: '/features/api-protection/'
              },
              {
                name: 'navigation.category2.list2.list4.list1.name7',
                link: '/features/bot-management/'
              },
              {
                name: 'navigation.category2.list2.list4.list1.name4',
                link: '/features/ddos-protection/'
              }
            ]
          }
        ]
      }
    ]
  },
  {
    key: 'pricing',
    name: 'navigation.category4.name',
    link: '/pricing/'
  },
  {
    key: 'resources',
    name: 'navigation.category3.name',
    list: [
      {
        name: '',
        list: [
          {
            key: 'speedtest',
            name: 'navigation.category5.name',
            list: [
              {
                name: 'navigation.category5.list1.name1',
                link: 'https://hubble.mlytics.com/basic_test',
                target: '_blank'
              },
              {
                name: 'navigation.category5.list1.name2',
                link: 'https://hubble.mlytics.com/cdn_comparison',
                target: '_blank'
              },
              {
                name: 'navigation.category5.list1.name3',
                link: 'https://hubble.mlytics.com/site_cdn_comparison',
                target: '_blank'
              },
              {
                name: 'navigation.category5.list1.name4',
                link: 'https://hubble.mlytics.com/site_mlytics_comparison',
                target: '_blank'
              }
            ],
            target: '_blank'
          },
          {
            name: 'navigation.category3.list1.name1',
            link: 'https://www.mlytics.com/blog/'
          },
          {
            name: 'navigation.category3.list1.name2',
            link: 'https://help.mlytics.com/',
            target: '_blank'
          },
          {
            name: 'navigation.category3.list1.name3',
            link: 'https://learning.mlytics.com/',
            target: '_blank'
          },
          {
            name: 'navigation.category3.list1.name5',
            link: '/about',
            target: '_blank'
          },
          {
            name: 'navigation.category3.list1.name6',
            link: 'https://www.mlytics.com/press-center/',
            target: '_blank'
          }
        ]
      }
    ]
  }
]
